import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Report } from '../models/report.model';
import { ToastService } from './toast.service';
import { GridService } from '../shared/grid/grid.service';

@Injectable({
    providedIn: 'root'
})
export class ReportService extends GridService<Report> {

    constructor(http: HttpClient, private toastService: ToastService) {
        super("Report", http);
    }

    /**
     * DASH-2758: reports (Letters + generic Reports) generated for a single sample, newest first.
     * The generic grid search cannot filter by sample, so the Sample Details page uses this
     * dedicated endpoint (relational Sample -> FileAttachment -> Report link on the backend).
     */
    getBySample(sampleId: string): Observable<Report[]> {
        return this.http.get<Report[]>(this.getApiUrl(`${this.controllerName}/GetBySample?sampleId=${sampleId}`)).pipe(
            catchError((error) => {
                this.toastService.showError(error);
                return of([]);
            })
        );
    }

    existsForEntity(type: string, entityId: string): Observable<boolean> {
        const params = new HttpParams().set('type', type).set('entityId', entityId);
        return this.http.get<boolean>(this.getApiUrl(`${this.controllerName}/ExistsForEntity`), { params });
    }
}
